module.exports = __webpack_public_path__ + "media/icons/arrow_right_grey-3c80958a.svg";